export default __webpack_public_path__ + "static/media/resume.46aef710.pdf";